<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<caass-schoolselector
								[ShowAll]="true"
								[ShowAllID]="SchoolSelectShowAllID"
								[ShowAllText]="SchoolSelectShowAllText"
								[IsReport]="true"
								[ReportID]="438"
							>
							</caass-schoolselector>
						</div>
					</div>

					<!--StartDate-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Date/Time</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar
								showIcon="true"
								showButtonBar="true"
								[(ngModel)]="report.StartDate"
								showTime="true"
								[hourFormat]="12"
								name="txtStartDate"
							></p-calendar>
						</div>
					</div>

					<!--EndDate-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">End Date/Time</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar
								showIcon="true"
								showButtonBar="true"
								[(ngModel)]="report.EndDate"
								showTime="true"
								[hourFormat]="12"
								name="txtEndDate"
							></p-calendar>
						</div>
					</div>

					<!--InfractionID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Infraction</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="InfractionID" [(ngModel)]="report.InfractionID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of InfractionList" [ngValue]="o.InfractionID">
									{{ o.InfractionDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--GradeLevelID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Grade Level</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GradeLevelID" [(ngModel)]="report.GradeLevelID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GradeLevelList" [ngValue]="o.GradeLevelID">
									{{ o.GradeLevelDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--ContinueAlert-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Continue Alert</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ContinueAlertID" [(ngModel)]="report.ContinueAlertID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ContinueAlertList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--OrderBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Order By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OrderByID" [(ngModel)]="report.OrderBy">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OrderByList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--SortOrder-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort Order</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortOrder" [(ngModel)]="report.SortOrderID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SortOrderList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
